module.exports = __webpack_public_path__ + "img/lecturers.103d0807.svg";